import { I18n, Store } from '../../wrappers';
import { ReportTypeLabel } from '../../types';
import Shift from '../Shift';
export class ReportLocalizationBa {
    report;
    constructor(client) {
        this.report = client;
    }
    static types(options = {}) {
        const { admin = false, isOnline: isOnlineOption, isRetail: isRetailOption, integrations: integrationsOption, modules: modulesOption } = options;
        const isRetail = isRetailOption ?? Store.get('isRetail');
        const isOnline = isOnlineOption ?? Store.get('isOnline');
        const integrations = integrationsOption ?? Store.get('integrations') ?? {};
        const modules = modulesOption ?? Store.get('modules') ?? {};
        return [
            {
                type: ReportTypeLabel.current_state,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.current_state'),
                timeOptions: ['today'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.current_state_legacy,
                processMode: 'legacy',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.current_state_legacy'),
                timeOptions: ['today'],
                enabled: true,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.daily_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.daily_report'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.daily_report_legacy,
                processMode: 'legacy',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.daily_report_legacy'),
                timeOptions: ['today'],
                enabled: true,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.periodic_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.periodic_report'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.periodic_report_legacy,
                processMode: 'legacy',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.periodic_report_legacy'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.shift_report,
                processMode: 'fiscal',
                category: I18n.t('reports.category.fiscal'),
                name: I18n.t('reports.shift_report'),
                timeOptions: ['shift'],
                // Any recent shift can be picked online (the admin is always online); offline only the open one.
                enabled: admin || !!isOnline || !!Shift.current(),
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_user_detailed,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_user_detailed'),
                timeOptions: ['shift'],
                enabled: !admin,
                fetchData: false,
                shared: false
            },
            {
                type: ReportTypeLabel.total_sales,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.total_sales'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_client,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_client'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_user,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_user'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_product,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_category,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_category'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: true,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_type,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_product_type_sent_to_room,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type_sent_to_room'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail && integrations.ota_sync,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_product_type_and_taxes,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_product_type_and_taxes'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail,
                fetchData: true,
                shared: true
            },
            {
                type: ReportTypeLabel.sales_by_sector,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_sector'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_table,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_table'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.sales_by_ingredient,
                processMode: 'sales',
                category: I18n.t('reports.category.sales'),
                name: I18n.t('reports.sales_by_ingredient'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !!modules.product_ingredients && isOnline && !isRetail,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.product_quantities,
                processMode: 'default',
                category: I18n.t('reports.category.other'),
                name: I18n.t('reports.product_quantities'),
                timeOptions: [],
                enabled: true,
                fetchData: true,
                shared: false
            },
            {
                type: ReportTypeLabel.bar_ledger,
                processMode: 'custom',
                category: I18n.t('reports.category.other'),
                name: I18n.t('reports.bar_ledger'),
                timeOptions: ['today', 'yesterday', 'byDate'],
                enabled: !isRetail,
                fetchData: true,
                width: '900px',
                shared: false
            }
        ];
    }
}
const ReportLocalizationBaStatic = ReportLocalizationBa;
//# sourceMappingURL=ReportLocalizationBa.js.map